import { Heading } from '@nbirl/nbi-common-ui-libs';

import { useDashboards } from '../../context';
import { DashboardsWorkbooksGrid } from './dashboards-workbooks-grid.component';

export const DashboardsCategory = () => {
  const { selectWorkbooksView, workbookUrl, workbooks } = useDashboards();

  return (
    <div className="pb-6">
      <Heading className="py-6 mb-1">{workbookUrl.category}</Heading>
      <DashboardsWorkbooksGrid
        workbooks={workbooks}
        onWorkbookSelect={(workbook) =>
          selectWorkbooksView({
            category: workbookUrl.category,
            workbook: workbook.name,
          })
        }
      />
    </div>
  );
};
